// extracted by mini-css-extract-plugin
module.exports = {"custom":"_99e06aedafc48ae13f1dc4fc94ee3c07-less"};